export enum USER_ROLE {
  CPAAS_ADMIN = "cpaas_admin",
}

export enum STATUS_CODES {
  Success = 200,
  Bad_Request = 400,
  Unauthorized = 401,
  Conflict = 409,
  Server_Error = 500,
}

export enum PAGE_SIZES {
  Default_List_Size = 5,
  Account_List_Dropdown = 10,
}

export enum GRID_COL_TYPES {
  Action_Icon = "actionIcon",
  Check_Element = "checkElement",
}

export enum CUSTOM_ERROR_MESSAGES {
  Cannot_Delete_Error = "This account cannot be deleted because it has one or more sub-accounts. It can only be deleted after all the sub-accounts are deleted via API calls.",
  No_Numbers_Found = "No Phone Numbers Found!",
  Something_Went_Wrong = "Oops! Something went wrong.",
}

export enum CUSTOM_MESSAGES {
  No_Brands_Yet = "No brands yet!",
  Create_Brand_Now = "Create a new brand now!",
  No_Family_Yet = "No family yet!",
  Create_Family_Now = "Create a new family now!",
  No_Brand_selected = "Select a brand",
  Brand_with_no_families = "Create a new family now!",
  No_Model_Yet = "No model yet!",
  Create_Model_Now = "Create a new model now!",
  No_Firmware_Yet = "No firmware yet!",
  Create_Firmware_Now = "Create a new firmware now!",
  No_File_Yet = "No file yet!",
  Create_File_Now = "Create a new file now!",
  No_Template_Yet = "No template yet!",
  Create_Template_Now = "Create a new template now!",
}
